module.exports = __webpack_public_path__ + "img/saber.cbf7912f.png";